
import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Dashboard from '../components/Dashboard';

const Index = () => {
  const [activeTab, setActiveTab] = useState('dashboard');
  const location = useLocation();

  // Handle state-based navigation (mainly for calendar)
  useEffect(() => {
    if (location.state?.activeTab) {
      setActiveTab(location.state.activeTab);
    }
  }, [location.state]);

  const renderContent = () => {
    switch (activeTab) {
      case 'calendar':
        return (
          <div className="p-6">
            <h1 className="text-2xl font-bold">Content Calendar</h1>
            <p className="text-gray-600">Calendar view coming soon...</p>
          </div>
        );
      default:
        return <Dashboard />;
    }
  };

  return (
    <div className="w-full">
      {renderContent()}
    </div>
  );
};

export default Index;
